import React,{useState,useEffect} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useMemo } from 'react';
import UserManagement from '../../Components/UserManagement';
import AuthUser from '../../AuthUser';
function Insurancecarriers() {
    const { http, getUser } = AuthUser();
    let userdetails = getUser();
    // Row Data: The data to be displayed.
    const [rowData, setRowData] = useState([]);

    const fetchData = () => {
        http.get(`admin/insurancecarriers/${userdetails.email}`)
            .then((response) => {
                setRowData(response.data.insurancecarriers)
            })
            .catch()
    }
    useEffect(() => {
        fetchData();
    }, [])
    const refreshData = () => {
        fetchData()

    }
    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([


        { headerName: 'Company Name', field: "company_name" },
    ]);


    // ...
    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            filter: true,
        }

    });





    return (
        <Container fluid>
            <UserManagement />

            <Row className='m-1 pt-2'>
                <Col sm={4} className='d-flex'>
                    <h6 className='fw-bold'>Customers </h6>
                </Col>
                <Col sm={4} className='pb-2'>

                </Col>
                <Col sm={4} >
                    <div class="dropdown float-end">

                    </div>
                </Col>

                <div className="ag-theme-alpine" // applying the grid theme
                    style={{ height: 550 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 20]}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}

                    />
                </div>


            </Row>

        </Container>

    );
}

export default Insurancecarriers